<template>
    <div>
        <van-nav-bar title="收款计划详情" left-arrow @click-left="onClickLeft" />
        <van-cell-group>
            <van-cell title="计划收款时间"  :value="data.planReceiptDate" />
            <van-cell title="计划收款金额" :value="data.planReceiptAmount" />
            <van-cell title="收款状态" :value="data.status" />
            <van-cell title="已收款" :value="data.receivedAmount" />
            <van-cell title="待收款" :value="data.planReceiptAmount - (Number(data.receivedAmount.replace(/,/g,'')) || 0) - (data.badDebtAmount || 0)" />
            <van-cell title="逾期天数" :value="data.overduedays" />
            <van-cell title="逾期金额" :value="data.beOverdue" />
            <van-cell title="坏账金额" :value="data.badDebtAmount" />
            <van-cell title="已开票" :value="data.invoicedAmount" />
            <van-cell title="待开票" :value="data.planReceiptAmount - (Number(data.invoicedAmount.replace(/,/g,'')) || 0)" />
            <van-cell title="开票状态" :value="(data.invoicedStatus == true ? '已开票' : '未开票')" />
        </van-cell-group>
    </div>
</template>
<script>
    /**
     * 引用
     */
    import {NavBar,Cell,CellGroup} from 'vant';
    import {getKey} from "../utils/url";

    export default {
        methods : {
            onClickLeft(){
                this.$router.push("/order/detail?id="+this.orderId+"&selected=1&isHiddenTitle=1&isSummaryEntry="+this.isSummaryEntry);
            }
        },
        created() {
            //获取url带过来的参数
            let objData = getKey('objData');
            this.orderId = getKey('orderId');
            this.isSummaryEntry = getKey('isSummaryEntry');
            objData = decodeURI(objData);
            objData = objData.replace(/%3A/g,':');
            this.data = JSON.parse(objData);
        },
        /**
         * 组件注册
         */
        components:{
            [NavBar.name]:NavBar,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup
        },
        data :function (){
            return{
                orderId:'',
                isSummaryEntry:false,
                data:{
                },
            }
        }
    }
</script>

<style scoped>
    .van-cell__value {
        position: relative;
        overflow: hidden;
        color: #000000;
        text-align: right;
        vertical-align: middle;
    }
    .van-cell {
        color: #969799;
        font-size: 14px;
        line-height: 24px;
    }
</style>